module.exports = __webpack_public_path__ + "static/img/close_dialog.67a9c509.png";